import { Component, OnInit } from '@angular/core';
import { CustomerStateService } from 'src/services/customer-state.service';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import {Location} from '@angular/common';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  isMobile: boolean;

  private explainerVideoLink: string;
  public customerName: string = 'United Auto Wash';
  public phoneNumber: string = '(330) 785-7801';
  public email: string = '';
  public address: string = "3465 S Arlington Rd, Suite E169, Akron, OH 44312";
  
  constructor( 
    public customerStateService: CustomerStateService,
    private _location: Location) {
  }

  async ngOnInit(){
    // remove ngif's from html
    let currentInfo = await firstValueFrom(this.customerStateService.currentCustomerInfo$);
    if(currentInfo){
      // set customer info for page
      this.customerName = currentInfo.name;
      this.phoneNumber = this.customerStateService.formatPhone(currentInfo.phoneNumber);
      this.email = currentInfo.email;
      this.address = null;
      this.explainerVideoLink = currentInfo.explainerVideoLink;
    }
    // otherwise just use no context data
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];
    
    this.isMobile = toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
  }

  emailUs(){
    var formattedBody = "FirstLine \n Second Line \n Third Line";
    var mailToLink = `mailto:${this.email}?body=` + encodeURIComponent(formattedBody);
    window.location.href = mailToLink;
  }

  messageUs(){
    var formattedBody = "FirstLine \n Second Line \n Third Line";
    var mailToLink = `smsto:${this.phoneNumber}`
    // var mailToLink = `smsto:${smsTarget}:body=` + encodeURIComponent(formattedBody); android
    window.location.href = mailToLink;
  }

  callUs(){
    var formattedBody = "FirstLine \n Second Line \n Third Line";
    var mailToLink = `tel:${this.phoneNumber}`
    window.location.href = mailToLink;
  }

  goToLink(){
    if (this.explainerVideoLink) {
      window.open(this.explainerVideoLink, "_blank");
    }
  }

  back(): void {
    this._location.back();
  }
}
